(function() {
	'use strict';
	/**
	 * @memberof app
	 *@ngdoc service
	 *@name UserService
	 *@description
	 *Servicio de autores
	 */

	angular
		.module('app')
		.factory('ProductsService', ProductsService);

	ProductsService.$inject = ["$http", "$window", "$location"];

	function ProductsService($http, $window, $location) {

		var sesion = {
			getAntigens: getAntigens,
		};

	    function getAntigens({ vm, filtros, category_parent_id, category_product, category_id,lang_id, callback }) {
			var config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
				}
			};

			$http.get('/ajax/getproductos', {
				params: {
					filtros: JSON.stringify(filtros),
					category_parent_id: category_parent_id,
					category_product: category_product,
				    category_id: category_id,
				    lang_id : lang_id
				},
				categorias_grupo: vm.categorias_grupo,
				categorias_caracter: vm.categorias_caracter
			}, config)
				.then(getContentSuccess, getContentFailed);

			function getContentSuccess(data) {
				callback(data.data); // ahora sí, callback existe
			}

			function getContentFailed(data) {
				return false;
			}
		}

		return sesion;
	}
})();

